<template>
  <div class="signed-in-with-trips" :class="signInWithTripsMap ? 'signed-in-with-trips-map' : ''" v-click-outside="close">
    <div class="container">
      <div class="box">
        <div class="select-a-trip">
          <span class="select-a-trip-tx">Select a Trip</span>
        </div>
        <div class="list-of-trips">
          <div :key="trip.id" v-for="(trip, index) in trips" class="list-of-trips-container">
            <div class="trip-info">
              <div v-if="trip.tripInfo.some(info => info.locationId === objectid)">
                <input type="checkbox" class="trip-checkbox" @change="deleteLocationFromTrip(trip)" :id="trip.name"
                  :value="trip.name" :checked="trip.tripInfo.some(info => info.locationId === objectid)" :key="index" />
              </div>
              <div v-else>
                <input v-if="!isLoading[index]" type="checkbox" class="trip-checkbox" @change="addLocationToTrip(index)"
                  v-model="addToTrip" :id="trip.name" :value="trip.name" :key="index" />
                <b-spinner v-if="isLoading[index]" small class="trip-checkbox-spinner" label="Small Spinner"></b-spinner>
              </div>
              <label class="trip-label" :for="trip.name">
                <p class="trip-name">{{ trip.name }}</p>
                <p class="trip-created-at">Created on {{ createdAt(trip.createdAt) }}</p>
              </label>
              <div class="trip-divider"></div>
            </div>
          </div>
        </div>
        <div class="create-a-trip">
          <div class="create-a-trip-container">
            <span v-b-modal.create-a-trip-modal class="create-a-trip-tx" @click="createTripWithLocation">+ Create a New
              Trip</span>
          </div>
          <b-modal id="create-a-trip-modal" hide-header hide-footer hide-backdrop scrollable>
            <Destination />
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import Destination from '../components/MyTrips/Destination.vue';
import { convertToDate } from '../store/helpers/helpers';

export default {
  name: 'overlay-signed-in-with-trip',
  components: { Destination },
  props: {
    objectid: {
      type: String,
    },
    slug: {
      type: String,
    },
    signInWithTripsMap: {
      type: Boolean,
    },
  },
  data() {
    return {
      isLoading: [],
      createdAt: date => convertToDate(date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' }),
      addToTrip: [],
    };
  },
  computed: {
    ...mapGetters({
      trips: 'myTrips/myTrips',
    }),
  },
  methods: {
    ...mapActions({
      editTrip: 'myTrips/editTrip',
      setNewTripItem: 'myTrips/setNewTripItem',
    }),
    async createTripWithLocation() {
      await this.setNewTripItem({
        slug: this.slug,
        locationId: this.objectid,
      });
    },
    async deleteLocationFromTrip(trip) {
      this.isLoading = [];
      const inOtherTrips = [];
      const filteredTripInfo = [...trip.tripInfo].filter(info => info.locationId !== this.objectid);
      try {
        const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
        const updatedTrip = {
          owner: user.username,
          tripId: trip.tripId,
          name: trip.name,
          locations: [...trip.locations].filter(loc => loc !== this.slug),
          routing: {
            begin: {
              lat: trip.routing.begin.lat,
              long: trip.routing.begin.long,
              city: trip.routing.begin.city,
              state: trip.routing.begin.state,
            },
            end: {
              lat: trip.routing.end.lat,
              long: trip.routing.end.long,
              city: trip.routing.end.city,
              state: trip.routing.end.state,
            },
          },
          tripInfo: filteredTripInfo,
        };
        await this.editTrip(updatedTrip);
        if (this.trips && this.trips.length > 0) {
          for (let i = 0; i < this.trips.length; i++) {
            const e = this.trips[i];
            for (let j = 0; j < e.tripInfo.length; j++) {
              const x = e.tripInfo[j].locationId;
              if (x === this.objectid) {
                inOtherTrips.push(x);
              }
            }
          }
        }
        if (inOtherTrips && inOtherTrips.length <= 1) {
          this.$root.$emit('disableHeart', this.$props.objectid);
        }
        if (this.$route.name === 'trip-details') {
          this.closeClick();
        }
      } catch (err) {
        console.log('Deleting location failed!', err);
      }
    },
    async addLocationToTrip(index) {
      try {
        this.checked(index);
        const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
        const filteredTrips = this.trips.filter(trip => this.addToTrip.includes(trip.name));
        filteredTrips.map(async (trip) => {
          if (trip.tripInfo.map(info => info.locationId).includes(this.objectid)) {
            // eslint-disable-next-line
            return;
          }
          const updatedTrip = {
            owner: user.username,
            tripId: trip.tripId,
            name: trip.name,
            locations: [...trip.locations, this.slug],
            routing: {
              begin: {
                lat: trip.routing.begin.lat,
                long: trip.routing.begin.long,
                city: trip.routing.begin.city,
                state: trip.routing.begin.state,
              },
              end: {
                lat: trip.routing.end.lat,
                long: trip.routing.end.long,
                city: trip.routing.end.city,
                state: trip.routing.end.state,
              },
            },
            tripInfo: [...trip.tripInfo, { locationId: this.objectid, show: true }],
          };
          await this.editTrip(updatedTrip);
          // eslint-disable-next-line
          return;
        });
        this.isLoading = [];
        await this.$root.$emit('enableHeart', this.$props.objectid);
      } catch (err) {
        this.isLoading = [];
        console.log('Adding location failed!', err);
      }
    },
    checked(index) {
      Vue.set(this.isLoading, index, 1);
    },
    close() {
      this.$root.$emit('hideOSIWT', false);
    },
    async closeClick() {
      await this.$store.dispatch('maps/resetSelectedLocation');
      this.infoOpened = false;
    },
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        // eslint-disable-next-line
        el.clickOutsideEvent = function (event) {
          event.stopPropagation();
          // here I check that click was outside the el and his childrens
          if (!(el === event.target || el.contains(event.target) || document.querySelector('#destination'))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
        document.body.addEventListener('touchstart', el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
        document.body.removeEventListener('touchstart', el.clickOutsideEvent);
      },
    },
  },
};
</script>

<style>
/* Override bootstrap modal backdrop and content classes */
div>div.modal {
  background-color: #fff;
  opacity: 0.98;
}

div>div.modal .modal-content {
  border: none;
}
</style>

<style scoped>
input[type="checkbox"].trip-checkbox {
  accent-color: #D86F48;
}

.signed-in-with-trips {
  position: absolute;
  left: -162px !important;
  margin-top: 5px;
  z-index: 999;
}

.signed-in-with-trips-map {
  left: 5px !important;
}

.select-a-trip {
  grid-area: select-a-trip;
  height: 20px;
  border-bottom: 1px solid #eaeaea;
  font-family: 'IdealSans-Medium';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1a3138;
  margin-top: 7px;
}

.list-of-trips {
  grid-area: list-of-trips;
  height: 140px;
}

.trip-checkbox {
  cursor: pointer;
  grid-area: trip-checkbox;
  margin: 0px 10px 10px 0px;
}

.trip-checkbox-spinner {
  margin: 0px 7px 5px 0px;
  min-height: 10px !important;
  min-width: 10px !important;
}

.trip-label {
  grid-area: trip-name;
  margin-left: 0px;
  margin-top: 0px;
  height: var(--spacing-xl);
}

.trip-name {
  font-family: 'IdealSans-Medium';
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  margin-bottom: 8px;
  width: 160px;
}

.trip-name:hover {
  cursor: pointer;
}

.trip-created-at {
  grid-area: trip-created-at;
  margin-top: 0px;
  font-size: 10px;
  font-weight: 300;
}

.trip-divider {
  grid-area: divider;
  margin: 8px 0 4px;
  width: 175px;
  border-top: solid 1px #eaeaea;
}

.trip-info {
  display: grid;
  width: 200px;
  height: auto;
  font-size: 12px;
  grid-template-areas: 'trip-checkbox trip-name'
    '. trip-created-at'
    '. divider';
}

.create-a-trip {
  grid-area: create-a-trip;
  border-top: 1px solid #eaeaea;
}

.create-a-trip-tx,
.close-overlay {
  font-family: 'IdealSans-Medium';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1a3138;
  cursor: pointer;
}

.select-a-trip-tx,
.list-of-trips-container,
.create-a-trip-container {
  margin-left: 9px;
  text-align: left;
}

.list-of-trips-container {
  margin-top: 8px;
}

.list-of-trips {
  height: 135px;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.list-of-trips::-webkit-scrollbar {
  display: none;
}

.list-of-trips::-webkit-scrollbar {
  display: none;
}

.box {
  display: grid;
  width: 210px;
  height: 200px;
  border: 1px solid #eaeaea;
  border-radius: 3px;
  background: #fff;
  cursor: default;
  grid-template-areas: 'select-a-trip'
    'list-of-trips'
    'create-a-trip';
}

input {
  margin-right: 10px;
  min-width: 10px !important;
}

.active-checkbox input:checked~.active-bg {
  background-color: green;
}
</style>
